<template>
    <div>
        <div class="main">
            <div class="nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
									<el-breadcrumb-item>物资管理</el-breadcrumb-item>
									<el-breadcrumb-item>机械设备</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
						<div class="cont">
							<div class="search">
								<div class="search-l">
									<div class="input"><el-input clearable v-model="searchList.equipName" placeholder="请输入设备名称" @change="getData"></el-input></div>
									<div class="input"><el-input clearable v-model="searchList.sn" placeholder="请输入设备序列号" @change="getData"></el-input></div>
									<div class="btn" @click="getData">搜索</div>
								</div>
								<div class="search-r">
									<div class="btn" @click="exportOut">导出表单</div>
									<div class="btn" @click="enter">退场记录</div>
									<div class="btn" @click="addItem">添加</div>
								</div>
							</div>
							<el-table
								:data="dataList"
								height="70vh"
								style="width: 100%">
								<el-table-column
									label="序号"
									width="90">
									<template slot-scope="scope">
										{{(pageNum-1)*pageSize+scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column
									prop="equipName"
									label="设备名称"
									>
								</el-table-column>
								<el-table-column
									prop="sn"
									label="序列号"
									>
								</el-table-column>
								<el-table-column
									prop="specifications"
									label="型号规格"
									>
								</el-table-column>
								<el-table-column
									prop="installationUnit"
									label="安装单位"
									>
								</el-table-column>
								<el-table-column
									
									label="安装位置"
									>
									<template slot-scope="scope">
										<div v-show="scope.row.location.lat">
											东经：{{scope.row.location.lat?scope.row.location.lat:''}} </br>北纬：{{scope.row.location.lng?scope.row.location.lng:''}}
										</div>
									</template>
								</el-table-column>

								<el-table-column
									prop="createDate"
									label="进场时间"
									>
								</el-table-column>
								<el-table-column
									prop="date"
									label="操作"
									width="190"
									>
									<template slot-scope="scope">
										<div class="btns">
											<div class="btn1" @click="edit(scope.row)">编辑</div>
											<div class="btn1" @click="tabText(scope.row)">报检文件</div>
											<div class="btn1" @click="delItem(scope.row)">退场</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageNum"
								:page-sizes="[10,20, 40, 80, 100]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="total"
								>
							</el-pagination>
							<el-dialog
								:title="indexS===1?'设备添加':'设备修改'"
								:visible.sync="dialogVisible"
								width="30%"
								:close-on-click-modal="false"
								>
								<el-form
                :model="addForm"
                ref="addForm"
                label-width="150px"
                
            >
                <el-form-item label="设备厂家：">
                    <el-input v-model="addForm.equipVender" placeholder="请输入设备厂家" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备序列号：">
                    <el-input v-model="addForm.sn" placeholder="请输入设备序列号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备名称：">
                    <el-input v-model="addForm.equipName" placeholder="请输入设备名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="型号规格：">
                    <el-input v-model="addForm.specifications" placeholder="请输入型号规格" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="安装单位：">
                    <el-input v-model="addForm.installationUnit" placeholder="请输入安装单位" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item label="检测单位：">
                    <el-input v-model="addForm.testingUnit" placeholder="请输入检测单位" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测报告及编号：">
                    <el-input v-model="addForm.testReportNumber" placeholder="请输入检测报告及编号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="检测日期：">
									<el-date-picker
											v-model="addForm.detectionDate"
											align="right"
											type="date"
											value-format="yyyy-MM-dd"
											placeholder="选择日期"
									></el-date-picker>
                </el-form-item>
                <el-form-item label="检测有效期：">
									<el-date-picker
											v-model="addForm.detectionValidityDate"
											align="right"
											type="date"
											value-format="yyyy-MM-dd"
											placeholder="选择日期"
									></el-date-picker>
                </el-form-item>
                <el-form-item label="检测报告：">
									<el-upload
										class="avatar-uploader"
										v-bind:action="uploadUrl"
										:headers="uploadHead"
										:data="{type:230}"
										:show-file-list="false"
										:on-success="devSuccess"
									>
										<img v-if="addForm.file" src="../../../assets/image/office/pdf.png" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
                </el-form-item> -->
								<el-form-item label="地图选点：">
                    <div class="box">
											<el-button @click="mapDian">地图选点</el-button>
										<el-input v-model="addForm.location.lat" disabled placeholder="请选择地理位置" autocomplete="off"></el-input>
										<el-input v-model="addForm.location.lng" disabled placeholder="请选择地理位置" autocomplete="off"></el-input>
										</div>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
							</el-dialog>
							<el-dialog
								title="位置选择"
								:visible.sync="dialogVisible1"
								width="50%"
								>
								<div class="map">
									<div class="data" v-if="currentPonit.length!==0">经度：{{currentPonit[0].lat}} 纬度：{{currentPonit[0].lng}}</div>
									<baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
                    <div class="mapBtn">
                        <button class="mapClear layui-btn layui-btn-danger" style="backgroundColor:#FD774B;" @click="mapClearAll">清空</button>
                    </div>
                    <div class="mapSearch">
                        <input type="text" v-model="searchInput" id="searchCon" style="width:300px;height:40px;margin:0;" />
                        <button class="layui-btn layui-btn-normal" @click="btnSearchFun" style="height:38px;top: -2px;position: relative;margin-left:10px;background:#43ADFC">查询</button>
                    </div>
								</div>
								<span slot="footer" class="dialog-footer">
									<el-button @click="dialogVisible1 = false">取 消</el-button>
									<el-button type="primary" @click="location">确 定</el-button>
								</span>
							</el-dialog>
							<el-dialog
            title="报检文件"
            :visible.sync="fileVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="50%"
        >
            <p style="width:100%;height:50px;position: relative;display: flex;justify-content: flex-end;justify-items: flex-end;align-content: center;align-items: center;">
                <el-button size="mini" type="primary" @click="toAddFile">添加文件</el-button>
            </p>
            <el-table :data="fileList" height="600px" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                <template slot="empty">
                    <p>{{fileText}}</p>
                </template>
                <el-table-column label="序号" type="index" width="100"></el-table-column>
                <el-table-column label="检测编号">
                    <template slot-scope="scope">
                        <span >{{scope.row.testReportNumber}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="有效期">
                    <template slot-scope="scope">
                        <span >{{scope.row.detectionValidityDate}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="报告文件">
                    <template slot-scope="scope">
                        <span style="cursor: pointer;" @click="toDetail(scope.row)">{{scope.row.fileName}}</span>
                    </template> 
                </el-table-column>
                <el-table-column label="上传日期">
                    <template slot-scope="scope">
                        <span>{{scope.row.detectionDate}}</span>
                    </template> 
                </el-table-column>
                <!-- <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="fileEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column> -->
                <!-- 内弹出 -->
                <el-dialog
                    width="30%"
                    :title="fileTxt"
                    :visible.sync="fileAddVis"
                    append-to-body>
                    <el-form
                        :model="addFile"
                        ref="addFile"
                        label-width="150px"
                        :label-position="labelPosition"
                        
                    >
												<el-form-item label="检测单位：">
														<el-input v-model="addFile.testingUnit" placeholder="请输入检测单位" autocomplete="off"></el-input>
												</el-form-item>
                        <el-form-item label="检测编号：" prop="testReportNumber">
                            <el-input v-model="addFile.testReportNumber" placeholder="请输入"></el-input>
                        </el-form-item>
												<el-form-item label="检测日期：">
													<el-date-picker
															v-model="addFile.detectionDate"
															align="right"
															type="date"
															value-format="yyyy-MM-dd"
															placeholder="选择日期"
													></el-date-picker>
												</el-form-item>
                        <el-form-item label="有效期：" prop="detectionValidityDate">
                            <el-date-picker
                                v-model="addFile.detectionValidityDate"
                                align="right"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="检测报告：">
									<el-upload
										class="avatar-uploader"
										v-bind:action="uploadUrl"
										:headers="uploadHead"
										:data="{type:230}"
										:show-file-list="false"
										:on-success="devSuccess"
									>
										<img v-if="addFile.file" src="../../../assets/image/office/pdf.png" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
                </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="fileAddVis = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitFileAdd('addFile')">确 定</el-button>
                    </div>
                </el-dialog>
             </el-table>
        </el-dialog>
						</div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
    export default {
			data() {
				return {
					dialogVisible: false,
					dialogVisible1: false,
					fileVis: false,
					fileAddVis:false,
					zoom:12,
					center: {lng: 117.283334, lat: 31.866339},
					local:'',//本地地图查询
					currentPonit:[],//当前区域的经纬度
					map:{},
					searchInput:'',
					labelPosition:'right',
					addForm:{
						id:'',
						projectId:'',
						equipVender:'',  //设备厂家
						sn:'',           //设备序列号
						equipName:'',    //设备名称
						specifications:'',//型号规格
						installationUnit:'',//安装单位
						testingUnit:'',//检测单位
						testReportNumber:'',//检测报告及编号
						detectionDate:'',////检测日期
						detectionValidityDate:'',////检测有效期
						file:'',
						fileName:'',
						remarks:'',
						equipType:'1', // 1机械 2电器
						location:''
          },
					searchList:{
						projectId:'',
						sn:'',
						delFlag:'0',
						equipType:'1',
						equipName:'',
					},
					pageSize:10,
					pageNum:1,
					uploadUrl: myHttp.uploadFile, //上传地址
					uploadHead: {
							accessToken: util.session.get('token')
					},
					dataList:[],
					indexS:1,
					fileList:[],
					fileText:'数据加载中...',
            //报检文件内弹出框
            fileTxt:'新增文件',
					addFile:{
                id:'',
                projectId:'',
                distributionId:'',
                testReportNumber:'',
                detectionValidityDate:'',
                file:'',
                fileName:'',
                caretBy:'',
            },
					row:{},
					total:''
				}
			},
			mounted(){
        this.addForm.projectId = util.session.get('groupId')
        this.searchList.projectId = util.session.get('groupId')
				this.getData()
			},
        methods:{
					exportOut(){
						let accessToken = this.$store.state.token
						let projectId = util.session.get('groupId')
						let delFlag = '0'
						let equipType = '1'
						let sn = this.searchList.sn
						let equipName  =this.searchList.equipName
						window.open(
							myHttp.exportInMechine + 
							'?projectId='+
							projectId +
							'&delFlag=' + 
							delFlag +
							'&equipType=' +
							equipType +
							'&accessToken=' +
							accessToken +
							'&sn=' +
							sn +
							'&equipName='+
							equipName
						)
					},
					sumbitFileAdd(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    
											that.addFile.distributionId = that.row.id
                        that.addFile.caretBy = util.session.get('user').id
												that.addFile.projectId = util.session.get('groupId')
                        myHttp.addDistributionMaintenance(that.addFile).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.fileAddVis = false
                                    myHttp.selectDistributionMaintenanceFile({
																		projectId:util.session.get('groupId'),
																		distributionId:that.row.id
																}).then(function(resp){
																		if(resp.data.code=='200'){
																				var list = resp.data.data.pageInfo||[]
																				that.fileList = list
																				if(list.length==0){
																						that.fileText = '暂无数据'
																				}
																		}else{
																				that.fileText = '暂无数据'
																		}
																})
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                }
            })
        },
					toAddFile(){
						this.fileAddVis = true
					},
					tabText(item){
						this.fileVis = true
						this.row = item
						var that = this
						myHttp.selectDistributionMaintenanceFile({
                projectId:util.session.get('groupId'),
                distributionId:item.id
            }).then(function(resp){
							
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo||[]
                    that.fileList = list
                    if(list.length==0){
                        that.fileText = '暂无数据'
                    }
                }else{
                    that.fileText = '暂无数据'
                }
            })
					},
				// 	addRow(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.exportTeamsAttend+"?projectId=" + this.groupId + '&teamsId=' + this.curTeam + '&date=' + this.teamSeach.date + '&personName=' + this.tableDataName + '&accessToken='+token);
        // },
					edit(item){
						this.addForm = { ...item }
						this.indexS = 2
						this.dialogVisible = true
						
					},
					delItem(item){
						 this.$confirm('设备是否确认退场！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							myHttp.deleteInfo({
							id:item.id,
							updateBy:util.session.get('user').id
						}).then(res=>{
							this.$message({
								type: 'success',
								message: `${res.data.msg}`
							});
							this.getData()
						})
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							});          
						});
					},
					enter(){
						this.$router.push({
							path:'/equipmentWalkOff'
						})
					},
					handleSizeChange(val){
						this.pageSize = val
						this.pageNum = 1
						this.getData()
					},
					handleCurrentChange(val){
						this.pageNum = val
						this.getData()
					},
					getData(){
						this.searchList.pageSize =  this.pageSize
						this.searchList.pageNum =  this.pageNum
						myHttp.getDistributionPageNew(this.searchList).then(res=>{
							if(res.data.code === 200){
								this.dataList = res.data.data.distribution.list
								console.log(res)
								this.total = res.data.data.distribution.total
								// this.dataList.location = JSON.parse(a)
								this.dataList.forEach((item,index)=>{
									this.dataList[index].location = JSON.parse(item.location)
								})
								
							}
						})

					},
					//提交
        sumbitAddRow(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if(that.indexS===1){
											  delete that.addForm.updateBy
                        that.addForm.createBy = util.session.get('user').id
												that.addForm.location = JSON.stringify(that.addForm.location)
                        myHttp.createInfoMeachine(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.addVis = false
                                    that.pageNum = 1
                                    that.getData()
																		that.dialogVisible = false
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }else{
											this.addForm.updateBy = util.session.get('user').id
											this.addForm1 = { ...this.addForm }
											that.addForm1.location = JSON.stringify(that.addForm1.location)
                        myHttp.updateInfoByMechine(this.addForm1).then(res=>{
												this.$message({
													message:`${res.data.msg}`,
													type:"success"
												})
												this.dialogVisible = false
												this.getData()
						})
                    }
                }
            })
        },
					//设备文件提交
        devSuccess(res,file){
            if(res.code=='200'){
                this.addFile.fileName = file.name
                this.addFile.file = res.data.saveUrls
								console.log(res)
            }else{
                this.$message.error(res.msg)
            }
        },
				location(){
					this.addForm.location = this.currentPonit[0]
					this.dialogVisible1=false
				},
					//地图展示
        handler ({BMap, map}) {
            this.map = map;
            this.geoc = new BMap.Geocoder();
            this.local = new BMap.LocalSearch(map, {
                renderOptions: { map: map }
            });
            // var point = new BMap.Point(this.center.lng, this.center.lat)
            // map.centerAndZoom(point, 13)
            // var marker = new BMap.Marker(point) // 创建标注
            // map.addOverlay(marker) // 将标注添加到地图中
            // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
            // map.addOverlay(circle)
        },
				//清空
        mapClearAll(){
            this.map.clearOverlays();
            
            this.currentPonit = [];
        },
					addItem(){
						this.dialogVisible = true
						this.addForm.id='',
						this.addForm.equipVender='',  //设备厂家
						this.addForm.sn='',           //设备序列号
						this.addForm.equipName='',    //设备名称
						this.addForm.specifications='',//型号规格
						this.addForm.installationUnit='',//安装单位
						this.addForm.testingUnit='',//检测单位
						this.addForm.testReportNumber='',//检测报告及编号
						this.addForm.detectionDate='',////检测日期
						this.addForm.detectionValidityDate='',////检测有效期
						this.addForm.file='',
						this.addForm.fileName='',
						this.addForm.remarks='',
						this.addForm.equipType='1', // 1机械 2电器
						this.addForm.location=''
						this.indexS = 1
					},
					mapDian(){
						this.dialogVisible1 = true
					},
					 btnSearchFun(){
            this.local.search(this.searchInput);
        },
					//地图点击方法
					getClickInfo (e) {
            // this.map.clearOverlays();
						this.mapClearAll()
            this.currentPonit.push(e.point);
            var point = new BMap.Point(e.point.lng, e.point.lat);
            // 创建标注  
            var marker = new BMap.Marker(point);
            // 将标注添加到地图中
            this.map.addOverlay(marker);
            if(this.currentPonit.length>=1){
                // this.clearPolygon();
                var list = [];
                for(var i=0;i<this.currentPonit.length;i++){
                    list.push(new BMap.Point(this.currentPonit[i].lng,this.currentPonit[i].lat));
                }
                var polygonList = new BMap.Polygon(list, {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5,strokeStyle: 'dashed',fillOpacity: 0.3});  //创建多边形
                this.map.addOverlay(polygonList);
                if(this.allPoint.length>0){
                    for(var i=0;i<this.allPoint.length;i++){
                        var oldList = this.allPoint[i];
                        list = [];
                        for(var j=0;j<oldList.length;j++){
                            list.push(new BMap.Point(oldList[j].lng,oldList[j].lat));
                        }
                        var polygonList = new BMap.Polygon(list, {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5,strokeStyle: 'dashed',fillOpacity: 0.3});  //创建多边形
                        this.map.addOverlay(polygonList);
                    }
                }
            }
						
        },
				}
    }
</script>

<style  scoped>
.main{
    height: 90.4vh;
    background-color: #F3F8FC;
    padding: 0 1% 0 0.5%;
}
.nav{
    height: 60px;
		display: flex;
		align-items: center;
}
.el-breadcrumb{
	font-size: 20px;
}
.cont{
	background-color: #fff;
	height: 82vh;
	border-radius: 6px;
	overflow: hidden;
}
.search{
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.btn{
	width: 100px;
height: 40px;
background: #0B62F0;
border-radius: 6px;
display: flex;
justify-content: center;
align-items: center;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
.btn:hover{
	cursor: pointer;
	opacity: 0.7;
}
.input{
	width: 200px;
height: 40px;
}
.search-l{
	margin-left: 10px;
	display: flex;
	width: 520px;
	justify-content: space-between;
}
.search-r{
	display: flex;
	width: 320px;
	justify-content: space-between;
	margin-right: 10px;
}
::v-deep .el-table th{
	background-color: #E6E6E6 !important;
}
.el-pagination{
	background-color: #E6E6E6 ;
}
.map{
	width: 100%;
	height: 45vh;
	background-color: #f00;
	position: relative;
  display: inline-block;
}
.mapBtn {
        z-index: 100;
        position: absolute;
        top: 5px;
        left: 5px;
        display: inline-block;
    }
    .mapBtn>button,.mapSearch>button{
    border: 0;
    outline: 0;
    padding: 10px;
    color:#fff
    }
    .mapSearch {
        position: absolute;
        top: 5px;
        right: 5px;
    }
		.data{
			position:absolute;
			left: 7px;top: -33px;
			z-index: 999;
			
		}
		.box{
			display: flex;
		}
		::v-deep .el-date-editor{
			margin-right: 164px;
		}
		.avatar-uploader{
			display: flex;
			justify-content: start;
		}
		.btns{
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.btns>.btn1{
			color: #2E5BE9;
		}

		.btns>.btn1:hover{
			opacity: 0.7;
			cursor: pointer;
		}
		.btns>.btn1:last-child{
			color:#f00;
		}
</style>